export default __webpack_public_path__ + "static/media/RaiseToken-shadow.ed0d4961.png";